import React, { useEffect, useRef, useState } from "react";
import Navbar from "../components/Navbar/Navbar";
import Sidebar from "../components/Sidebar/Sidebar";
import { useUsuario } from "../context/usuarioContext";
import socketIOClient, { Socket, io } from "socket.io-client"
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import Agendar from "../modules/plan/components/Agendar/Agendar";
import CustomModal from "@sistemas.mundo/custom-modal";
import useSetAgendamiento from "../queries/solicitudes/useSetAgendamiento";
import useEstadoContrato from "../queries/plan/useEstadoContrato";
import useContratos from "../queries/config/useContratos";


const Layout = ({ children }) => {
  const navigate = useNavigate();
  const queryContratos = useContratos();
  const intervalRef = useRef(null);
  const [showMenu, setShowMenu] = useState(false);
  const [selectedItem, setSelectedItem] = useState('');
  const [selectedItemNoExpanded, setSelectedItemNoExpanded] = useState('')
  const [subSelectedItem, setSubSelectedItem] = useState('')
  const [navSelectedItem, setNavSelectedItem] = useState('');
  const [expandedItems, setExpandedItems] = useState({
    boleta: false,
    plan: false,
    solicitud: false,
  });
  const { usuario, contratos, setContratos } = useUsuario();

  const [contratoSeleccionado, setContratoSeleccionado] = useState()

  useEffect(() => {
    if (contratos)
      setContratoSeleccionado(contratos[0])
  }, [contratos])

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setShowMenu(false);
      }
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const [parametrosConfirmacion, setParametrosConfirmacion] = useState({
    idContrato: "",
    hora_id: "",
    agen_fecha: "",
    agen_usuario_agenda: "",
    telefono_cliente: "",
    origen: "sv",
    rut: "",
    agen_fecha_mostrar: "",
    carga: true,
  });

  const [modalAgendar, setModalAgendar] = useState(null)

  const apiEstadoContrato = useEstadoContrato();

  const startPolling = () => {

    if (intervalRef.current) return;

    intervalRef.current = setInterval(async () => {
      try {
        const response = await apiEstadoContrato.mutateAsync();


        if (response.success.descripcionRespuesta.cont_estado === 11) {
          clearInterval(intervalRef.current);
          intervalRef.current = null;
          Swal.fire({
            icon: success,
            title: "Cambio de plan exitoso.",
            confirmButtonText: "Aceptar",
            focusConfirm: false,
            iconColor: "green",
            width: "40rem",
            customClass: {
              popup: "containerSwal",
              title: "titleSwal",
              closeButton: "...",
              icon: "iconSwal",
              confirmButton: "buttonSwal",
              denyButton: "...",
              cancelButton: "...",
            },
          }).then(function () {

            window.location.reload();
          });

        }
      } catch (error) {
        console.error("Error en el polling:", error);
      }
    }, 30000); //30s
  };
  const [planSeleccionado, setPlanSeleccionado] = useState(null)
  const [direccionSeleccionada, setDireccionSeleccionada] = useState(null)
  useEffect(() => {

    if (usuario) {
      var endpoint = "https://socket2.tumundo.cl";
      const socket = socketIOClient(endpoint);
      let auxHas = usuario.Correo;

      socket.on("connect", () => {
        socket.emit("mundoSocial", {
          hashID: auxHas,
          mensaje: "front sv",
        });
      });

      socket.on("stats", async (mensaje) => {

        if (mensaje && mensaje.tipo) {
          navigate("/");

          const contratoCliente = await queryContratos.mutateAsync({
            rutCliente: usuario.RutClient,
          });

          const respuestaContratos = contratoCliente.success.descripcionRespuesta
          setContratos(respuestaContratos);
          Swal.fire({
            icon: mensaje.tipo,
            title: mensaje.mensaje,
            confirmButtonText: "Aceptar",
            focusConfirm: false,
            iconColor: mensaje.tipo ? "green" : "red",
            width: "40rem",
            customClass: {
              popup: "containerSwal",
              title: "titleSwal",
              closeButton: "...",
              icon: "iconSwal",
              confirmButton: "buttonSwal",
              denyButton: "...",
              cancelButton: "...",
            },
          }).then(function (response) {
            console.log("Mesaje:", mensaje)
            if (mensaje.tico_id && mensaje.tico_id == 1) {
           
              window.location.reload();
              //startPolling();
            }
            else if (mensaje.tico_id && mensaje.agendamiento) {

              setPlanSeleccionado(mensaje.plan ? mensaje.plan.nombre : "No disponible");

              const direccion = respuestaContratos.find((item) => item.id_contrato == mensaje.idContrato);
              setDireccionSeleccionada(`${direccion.hp.hp_calle} ${direccion.hp.hp_numero}, ${direccion.hp.hp_comuna}`)

              setModalAgendar(mensaje.idContrato)
            }
          });
        }

      });

      socket.on("disconnect", (reason) => {

      });

      socket.on("reconnect", function () {

        socket.emit("mundoSocial", {
          hashID: auxHas,
          mensaje: "front sv",
        });
      });

      return () => socket.disconnect();
    }



  }, [usuario]);


  const querySetAgendamiento = useSetAgendamiento();
  const agendarVisita = (idContrato) => {

    querySetAgendamiento.mutate({
      idContrato: idContrato,
      hora_id: parametrosConfirmacion.hora_id,
      agen_fecha: parametrosConfirmacion.agen_fecha,
      agen_usuario_agenda: usuario.Correo,
      telefono_cliente: usuario.Telefono,
      origen: parametrosConfirmacion.origen,
      rut: usuario.RutClient,
      agen_hora: parametrosConfirmacion.agen_hora,
    });
  }

  useEffect(() => {
    if (querySetAgendamiento.isSuccess) {

      setOpenResumenModal(true);
    }
  }, [querySetAgendamiento.isSuccess])


  // Validación de campos obligatorios para agendar
  const [btnAceptar, setBtnAceptar] = useState(false)

  useEffect(() => {
    if (!parametrosConfirmacion.carga) {
      setBtnAceptar(true);
    }
  }, [parametrosConfirmacion])


  // Estado para mostrar el modal y los datos
  const [openResumenModal, setOpenResumenModal] = useState(false);
  const [resumenData, setResumenData] = useState({
    nombreTitular: '',
    fechaSolicitud: '',
    planSolicitado: '',
    direccion: '',
    fechaInstalacion: '',
    hora: '',
    activo: true
  });

  const getFechaActual = () => {
    const hoy = new Date();
    const dia = String(hoy.getDate()).padStart(2, '0');
    const mes = String(hoy.getMonth() + 1).padStart(2, '0');
    const anio = hoy.getFullYear();
    return `${dia}/${mes}/${anio}`;
  };

  return (
    <>
      <div className="page">
        <header className="page__header">
          <div className="navbar">
            <Navbar
              navSelectedItem={navSelectedItem}
              setNavSelectedItem={setNavSelectedItem}
              setSelectedItem={setSelectedItem}
              setSelectedItemNoExpanded={setSelectedItemNoExpanded}
              setSubSelectedItem={setSubSelectedItem}
              expandedItems={expandedItems}
              setExpandedItems={setExpandedItems}
              contratos={contratos}
              setShowMenu={setShowMenu}
            />
          </div>
        </header>
        <aside className={`sidebar ${showMenu ? 'sidebar--mobile' : ''}`}>
          <Sidebar
            showMenu={showMenu}
            setShowMenu={setShowMenu}
            selectedItem={selectedItem}
            setSelectedItem={setSelectedItem}
            selectedItemNoExpanded={selectedItemNoExpanded}
            setSelectedItemNoExpanded={setSelectedItemNoExpanded}
            subSelectedItem={subSelectedItem}
            setSubSelectedItem={setSubSelectedItem}
            navSelectedItem={navSelectedItem}
            setNavSelectedItem={setNavSelectedItem}
            expandedItems={expandedItems}
            setExpandedItems={setExpandedItems}
            contratos={contratos}
            contratoSeleccionado={contratoSeleccionado}
            setContratoSeleccionado={setContratoSeleccionado}
          />
        </aside>
      </div>

      <CustomModal
        fullWidth={true}
        title={"Calendario disponible"}
        titleStyle={{
          height: "20px",
          display: "flex",
          alignItems: "flex-end",
          borderRadius: "2px",
        }}
        isModalOpened={modalAgendar}
        handleCloseModal={() => setModalAgendar(null)}
        body={
          <Agendar idContrato={modalAgendar} parametrosConfirmacion={parametrosConfirmacion} setParametrosConfirmacion={setParametrosConfirmacion} />
        }
        showOk={btnAceptar}
        callbackOk={() => agendarVisita(modalAgendar)}
        //showCancel={false}
        maxWidth="md"
        closeOnOk={true}
      />

      {/* Modal de resumen de solicitud e instalación */}
      <CustomModal
        isModalOpened={openResumenModal}
        handleCloseModal={() => {


          setOpenResumenModal(false)
          window.location.reload();
        }

        }
        title="Resumen de Solicitud"
        //showOk={true}
        fullWidth={true}
        callbackOk={() => {
          setOpenResumenModal(false)
          window.location.reload();

        }}
        body={<div style={{ fontFamily: 'Montserrat' }}>
          <div><b>Nombre titular:</b> {usuario?.Nombres ?? ""} {usuario?.ApPaterno ?? ""} {usuario?.ApMaterno ?? ""}</div>
          <br></br>
          <div><b>Fecha de solicitud:</b> {getFechaActual()}</div>
          <br></br>
          <div><b>Plan solicitado:</b> {planSeleccionado}</div>
          <hr style={{ margin: '10px 0' }} />
          <div><b>Dirección instalación:</b> {direccionSeleccionada}</div>
          <br></br>
          <div><b>Fecha instalación:</b> {parametrosConfirmacion.agen_fecha}</div>
          <br></br>
          <div><b>Hora:</b> {parametrosConfirmacion.agen_hora}</div>
        </div>}
      />


      {
        !showMenu ? (
          <main className="page__main">
            <section className="page__main-content">
              {children}
            </section>
          </main>
        ) : null
      }
    </>
  );
};

export default Layout;